import React from "react";
import { affordances } from "../../../util/analytics";
import InlineMedia from "../../InlineMedia";

export default function useInlineVideoProcessor({
  videos,
  handleOpenLightBoxVideo,
}) {
  const processInlineVideo = (node) => {
    const title = node.attribs["data-title"];
    const publicId = node.attribs["data-public-id"];
    const copyright = node.attribs["data-copyright"];
    const description = node.attribs["data-description"];
    const isMediaClickDisabled =
      node.attribs["data-type"] === "disable-media-click";
    const videoIndex = videos.findIndex((video) => video.publicId === publicId);
    return (
      <InlineMedia
        title={title}
        publicId={publicId}
        copyright={copyright}
        description={description}
        isMediaClickDisabled={isMediaClickDisabled}
        index={videoIndex}
        openMediaHandler={() =>
          handleOpenLightBoxVideo(videoIndex, affordances.INLINE_TOPIC)
        }
        mediaType={"video"}
        media={videos[videoIndex]}
        maxIndex={videos.length}
      />
    );
  };

  return {
    processInlineVideo,
  };
}
